import React from 'react';

import Google from 'shared-vectors/icons/DsGoogle';
import { Icon } from 'shared-vectors';

import createStyle from 'shared-utils/src/createStyle';

import Grid from '../../../../Grid';

import style, { mainCls } from './style';

const useStyles = createStyle(style);

export default ({
  action,
  className,
}) => {
  const cls = useStyles();
  return (
    <Grid
      justify="center"
      align="center"
      className={`${cls[mainCls]} ${className} c-txt--f0 c-bg--w b--s`}
      onClick={action}
    >
      <Icon name={Google} width="24px" height="24px" illustration className="mr--xs" /> Continua con Google
    </Grid>
  );
};
